import { useContext } from 'react';
import { createContext } from 'react';

import { SearchBarProps } from '../@types/SearchBarProps';

export const SearchBarContext = createContext<SearchBarProps>({} as SearchBarProps);

SearchBarContext.displayName = 'SearchBar';

const SearchBarProvider = (props: SearchBarProps) => (
	<SearchBarContext.Provider value={props}>{props.children}</SearchBarContext.Provider>
);

export const useSearchBar = () => {
	const context = useContext(SearchBarContext);

	return context;
};

export default SearchBarProvider;
